import React from 'react';
import {
    AuthFormContainer,
    AuthFormWrapper,
    AuthFormMainContent,
    AuthFormSubtitle,
    AuthFormHeader,
} from './AuthForm.style';
import { Link as RouterLink } from 'react-router-dom';
import { Container, Grid, Link, Typography } from '@material-ui/core';
import AuthFooter from '../AuthFooter/AuthFooter';
import AuthFooterSecondary from '../AuthFooter/AuthFooterSecondary';
import { useTranslation } from 'react-i18next';

export const AuthForm = ({ children, title, subtitle }) => {
    const { t } = useTranslation();
    return (
        <AuthFormWrapper>
            <AuthFormMainContent>
                <Container mb={4}>
                    <Grid container justify="center">
                        <Grid item xs={12} sm={8}>
                            <AuthFormContainer>
                                <Typography
                                    variant="h1"
                                    align="center"
                                    style={{ fontWeight: '500' }}
                                >
                                    {title}
                                </Typography>
                                <AuthFormSubtitle variant="body1" align="center">
                                    {subtitle}
                                    {window.location.pathname === '/sign-up' ? (
                                        <Link variant="secondary" component={RouterLink} to="/">
                                            {t('LogIn')}
                                        </Link>
                                    ) : (
                                        <Link
                                            variant="secondary"
                                            component={RouterLink}
                                            to="/sign-up"
                                        >
                                            {t('SignUp')}
                                        </Link>
                                    )}
                                </AuthFormSubtitle>
                                <div>{children}</div>
                            </AuthFormContainer>
                        </Grid>
                    </Grid>
                </Container>
                <AuthFooter />
                <AuthFooterSecondary />
            </AuthFormMainContent>
        </AuthFormWrapper>
    );
};
